import * as React from 'react';
import { useEffect } from 'react';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Foodtabs from "./Foodtabs";
import hoistoryStore from "../store/historyStore";
import * as util from "../utils/util";
import api from "../utils/api";
import { useLocation, useNavigate } from "react-router-dom";
import { notifyApiError } from "../utils/apiError";

export default function HistoryFoodInput(props: any) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { targetDate, targetDayValue } = state ?? {};
  const storeData: any = hoistoryStore();

  useEffect(() => {
  }, []);

  const handleClose = () => {
    navigate('/history/eat', { state: { targetDateBack: targetDate, targetDayValue: targetDayValue } });
  };


  // 음식 저장
  async function handleComplete(value: any) {
    const series = ['morning', 'lunch', 'dinner', 'snack'];

    for (const sr of series) {
      let saveParams = { date: '', gubun: '', name: '', calory: '', amount: '' };
      saveParams.date = targetDate.slice(0, 4) + '-' + targetDate.slice(4, 6) + '-' + targetDate.slice(6, 8);
      saveParams.gubun = sr;
      saveParams.name = storeData.selectedFoodList.filter((v: any) => v.gubun === sr).map((v: any) => v.name).join('--');
      saveParams.calory = storeData.selectedFoodList.filter((v: any) => v.gubun === sr).map((v: any) => util.strNull(v.calory * v.amount)).join('--');
      saveParams.amount = storeData.selectedFoodList.filter((v: any) => v.gubun === sr).map((v: any) => util.strNull(v.amount)).join('--');

      await api.post(`app/api/v1/AP_002_006`, saveParams).then(res => {
      }).catch(function (error) {
        // 저장 실패를 알리지 않으면 사용자는 기록이 남은 줄 안다
        notifyApiError(error, '식사 기록을 저장하지 못했습니다.');
      });
    }
    storeData.setSelectedFoodList([]);
    navigate('/history/eat', { state: { targetDateBack: targetDate, targetDayValue: targetDayValue } });
  }




  return (
    <React.Fragment>
      <Stack sx={{ width: '100%', minWidth: 320, height: '100%', background: '#fff', pb: 10, px: 2, pt: 2, boxSizing: 'border-box' }} spacing={6}>
        <Stack>
          <Typography
            sx={{
              color: '#333',
              fontSize: 18,
              fontWeight: 700,
              textAlign: 'center',
              mb: '20px',
              borderBottom: '1px solid #ddd',
              pb: 2
            }}
          >
            오늘의 음식을 입력하세요
          </Typography>

          <Box>
            <List sx={{ m: 0, border: '1px solid #ccc', p: 0, borderRadius: 4, }}>
              <Foodtabs />
            </List>
          </Box>

        </Stack>

      </Stack>
      <Stack direction={'row'} spacing={2} sx={{ position: 'fixed', bottom: 0, px: 2, width: '100%', boxSizing: 'border-box', bgcolor: '#f5f5f5', py: 1.5 }}>
        <EditButton onClick={handleClose}>
          취소
        </EditButton>
        <EditButton onClick={handleComplete} sx={{ backgroundColor: '#EF8322', color: '#fff' }}>
          저장
        </EditButton>
      </Stack>


    </React.Fragment>
  );
}

const search_Fome_Style = {
  m: '10px auto',
  p: '0px 10px',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  borderRadius: '24px',
  boxShadow: 'inset 0 0 4px rgba(0,0,0,0.4)',
  boxSizing: 'border-box'
};

const bottomBtn = {
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px 20px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  color: '#fff',
  width: '100%',
  borderRadius: '20px',
  mt: 3,
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
}

const EditButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 20px',
  lineHeight: 1.5,
  backgroundColor: '#fff',
  border: '1px solid #EF8322',
  borderRadius: '20px',
  color: '#EF8322',
  margin: '10px 0 30px 0',
  width: '90%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});